import { jsx as _jsx } from "react/jsx-runtime";
import { flexRender } from '@tanstack/react-table';
import classNames from 'classnames';
import { getCellStylesFromCtx } from '../../../../../infra/ui/table/utils';
import styles from './styles.module.scss';
export var TableHeader = function (_a) {
    var table = _a.table;
    var headerGroups = table.getHeaderGroups();
    return (_jsx("div", { children: headerGroups.map(function (headerGroup) { return (_jsx("div", { className: styles.thead, children: headerGroup.headers.map(function (header) {
                var _a;
                return (_jsx("div", { className: classNames(styles.th, (_a = {}, _a[styles['status-header']] = header.id === 'status', _a)), style: getCellStylesFromCtx({ ctx: header.getContext(), stretchItems: 'flex' }), children: flexRender(header.column.columnDef.header, header.getContext()) }, header.id));
            }) }, headerGroup.id)); }) }));
};
